import { saveAs } from 'file-saver';
import { downloadJobDescription } from 'wisestep-api';

const downloadJD = async (jobId: string) => {
  const downloadDetails = await downloadJobDescription(jobId);
  const headers = downloadDetails.headers;
  const file = new Blob([downloadDetails.data], {
    type: headers['content-type'],
  });
  saveAs(file, headers['content-disposition'].replace('attachment; filename=', ''));
};

export default downloadJD;
